import React from 'react';

import Input from './Input';

const Select = (props) => {
  return <Input {...props} as="select" custom />;
};

export default Select;
